var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtnActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193,
    height: 48,
    viewBox: "0 0 193 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 185,
    height: 40,
    x: 0,
    y: 0,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "104.3%",
    height: "125%",
    x: "-2.2%",
    y: "-10%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3367D6",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M60.21 26.44c0-.44-.15-.78-.46-1.02-.3-.23-.86-.47-1.66-.71a8.04 8.04 0 0 1-1.92-.81c-.9-.57-1.36-1.31-1.36-2.23 0-.8.33-1.46.98-1.98.66-.52 1.5-.78 2.55-.78.7 0 1.31.13 1.85.38a3 3 0 0 1 1.75 2.66H60.2c0-.52-.16-.92-.48-1.22-.33-.3-.8-.44-1.4-.44-.57 0-1 .12-1.32.36a1.2 1.2 0 0 0-.47 1.02c0 .36.17.66.5.9.35.25.9.49 1.68.72.77.23 1.4.5 1.86.78.47.3.82.64 1.04 1.02.21.38.32.82.32 1.33 0 .83-.31 1.5-.95 1.98-.64.5-1.5.74-2.59.74-.72 0-1.38-.14-1.98-.4a3.34 3.34 0 0 1-1.41-1.1 2.75 2.75 0 0 1-.5-1.65h1.73c0 .57.18 1 .56 1.31.37.31.9.47 1.6.47.6 0 1.06-.12 1.36-.37.3-.24.45-.56.45-.96zM65.3 29h-1.67v-7.4h1.67V29zm-1.77-9.32c0-.25.08-.46.25-.63a.9.9 0 0 1 .69-.26c.3 0 .53.09.7.26.16.17.24.38.24.63s-.08.46-.24.63a.98.98 0 0 1-.7.25.98.98 0 0 1-.7-.25.86.86 0 0 1-.24-.63zm3.5 5.57c0-1.15.27-2.07.81-2.75a2.6 2.6 0 0 1 2.15-1.03c.85 0 1.5.3 2 .88l.07-.75h1.5v7.17c0 .98-.3 1.74-.91 2.3-.6.56-1.42.84-2.45.84-.54 0-1.07-.11-1.59-.34a2.82 2.82 0 0 1-1.17-.88l.78-1c.51.6 1.14.91 1.89.91.55 0 .99-.15 1.3-.45.32-.3.48-.74.48-1.31v-.5c-.48.53-1.11.8-1.91.8a2.6 2.6 0 0 1-2.12-1.04 4.47 4.47 0 0 1-.83-2.85zm1.66.14c0 .74.15 1.33.45 1.75.3.43.72.64 1.26.64a1.6 1.6 0 0 0 1.5-.86v-3.25a1.59 1.59 0 0 0-1.48-.84c-.55 0-.98.21-1.28.65-.3.43-.45 1.07-.45 1.91zM77 21.6l.05.86c.54-.66 1.26-1 2.15-1 1.54 0 2.33.89 2.35 2.65V29H79.9v-4.8c0-.46-.1-.8-.3-1.03-.2-.23-.54-.34-1-.34-.67 0-1.17.3-1.5.9V29h-1.66v-7.4h1.57zM88.95 29h-1.67v-7.4h1.67V29zm-1.77-9.32c0-.25.08-.46.24-.63.17-.17.4-.26.7-.26.3 0 .53.09.7.26.16.17.24.38.24.63s-.08.46-.24.63a.98.98 0 0 1-.7.25.98.98 0 0 1-.7-.25.86.86 0 0 1-.24-.63zm5.33 1.92l.05.86c.55-.66 1.27-1 2.15-1 1.55 0 2.33.89 2.36 2.65V29H95.4v-4.8c0-.46-.1-.8-.3-1.03-.21-.23-.54-.34-1-.34-.67 0-1.17.3-1.5.9V29h-1.66v-7.4h1.56zm16.67 5.11l1.18-5.1h1.62L109.96 29h-1.37l-1.58-5.08-1.56 5.08h-1.37l-2.02-7.4h1.62l1.2 5.06 1.51-5.06h1.25l1.54 5.11zm5.9 2.29h-1.67v-7.4h1.66V29zm-1.77-9.32c0-.25.08-.46.24-.63.16-.17.4-.26.7-.26.3 0 .53.09.7.26.16.17.24.38.24.63s-.08.46-.25.63a.96.96 0 0 1-.7.25.94.94 0 0 1-.69-.25.86.86 0 0 1-.24-.63zm5.87.13v1.8h1.3v1.22h-1.3v4.13c0 .29.06.49.17.61.11.13.3.2.6.2.19 0 .38-.03.58-.08v1.29c-.38.1-.75.16-1.1.16-1.27 0-1.91-.7-1.91-2.12v-4.19h-1.22V21.6h1.22v-1.8h1.66zm4.43 2.6a2.6 2.6 0 0 1 2.06-.94c1.57 0 2.37.9 2.4 2.7V29h-1.66v-4.77c0-.51-.11-.87-.34-1.08-.22-.22-.54-.32-.97-.32-.66 0-1.16.3-1.49.89V29h-1.66V18.5h1.66v3.91zm17.85 5.3a3.3 3.3 0 0 1-1.5 1.06 6.1 6.1 0 0 1-2.17.37c-.84 0-1.57-.2-2.22-.57a3.78 3.78 0 0 1-1.48-1.62 5.68 5.68 0 0 1-.55-2.47v-.78c0-1.5.36-2.68 1.08-3.52a3.75 3.75 0 0 1 3.02-1.27c1.1 0 1.98.27 2.64.82a3.54 3.54 0 0 1 1.17 2.37h-1.7c-.18-1.2-.88-1.8-2.08-1.8-.77 0-1.36.28-1.77.84a4.3 4.3 0 0 0-.62 2.45v.77c0 1.07.23 1.9.68 2.5.45.6 1.08.9 1.89.9.88 0 1.51-.2 1.89-.6V25.2h-2.05v-1.32h3.77v3.82zm1.65-2.48c0-.72.14-1.37.43-1.96a3.1 3.1 0 0 1 1.2-1.33 3.4 3.4 0 0 1 1.8-.47c1 0 1.8.32 2.43.96.62.64.96 1.5 1 2.56l.01.39a4.4 4.4 0 0 1-.42 1.95 3.1 3.1 0 0 1-1.2 1.34c-.52.3-1.12.47-1.8.47a3.2 3.2 0 0 1-2.51-1.05 4 4 0 0 1-.94-2.77v-.09zm1.66.15c0 .76.15 1.35.47 1.78.31.44.75.65 1.31.65s1-.22 1.31-.66a3.3 3.3 0 0 0 .47-1.92c0-.74-.16-1.34-.48-1.77a1.54 1.54 0 0 0-1.31-.66c-.54 0-.97.22-1.3.65a3.23 3.23 0 0 0-.47 1.93zm6.53-.15c0-.72.14-1.37.43-1.96a3.1 3.1 0 0 1 1.2-1.33 3.4 3.4 0 0 1 1.8-.47c1 0 1.8.32 2.43.96.62.64.96 1.5 1 2.56l.01.39a4.4 4.4 0 0 1-.42 1.95 3.1 3.1 0 0 1-1.2 1.34c-.52.3-1.13.47-1.8.47a3.2 3.2 0 0 1-2.51-1.05 4 4 0 0 1-.94-2.77v-.09zm1.66.15c0 .76.15 1.35.47 1.78.31.44.75.65 1.31.65s1-.22 1.31-.66a3.3 3.3 0 0 0 .47-1.92c0-.74-.16-1.34-.48-1.77a1.54 1.54 0 0 0-1.31-.66c-.54 0-.98.22-1.3.65a3.23 3.23 0 0 0-.47 1.93zm6.55-.13c0-1.15.27-2.07.8-2.75a2.6 2.6 0 0 1 2.16-1.03c.84 0 1.5.3 1.99.88l.07-.75h1.5v7.17c0 .98-.3 1.74-.9 2.3-.61.56-1.43.84-2.45.84-.54 0-1.07-.11-1.6-.34a2.82 2.82 0 0 1-1.17-.88l.79-1c.5.6 1.13.91 1.88.91.55 0 .99-.15 1.3-.45.33-.3.49-.74.49-1.31v-.5c-.48.53-1.12.8-1.92.8a2.6 2.6 0 0 1-2.12-1.04 4.47 4.47 0 0 1-.82-2.85zm1.65.14c0 .74.15 1.33.45 1.75.3.43.73.64 1.27.64a1.6 1.6 0 0 0 1.49-.86v-3.25a1.59 1.59 0 0 0-1.48-.84c-.55 0-.97.21-1.28.65-.3.43-.45 1.07-.45 1.91zm8.56 3.61h-1.66V18.5h1.66V29zm5.28.14c-1.05 0-1.9-.33-2.56-1a3.6 3.6 0 0 1-.98-2.65v-.2c0-.74.14-1.4.43-1.98a3.17 3.17 0 0 1 2.92-1.84c1 0 1.79.32 2.34.96.55.64.82 1.55.82 2.73v.67h-4.83c.05.6.25 1.1.6 1.45.37.35.82.53 1.36.53.76 0 1.38-.3 1.86-.92l.9.85a3 3 0 0 1-1.2 1.03c-.49.24-1.04.37-1.66.37zm-.2-6.34c-.45 0-.82.16-1.1.48a2.5 2.5 0 0 0-.54 1.33h3.17v-.12a2.02 2.02 0 0 0-.45-1.26 1.39 1.39 0 0 0-1.08-.43z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 5,
    y: 5,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M32.64 24.2c0-.63-.06-1.25-.16-1.84H24v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92a8.78 8.78 0 0 0 2.68-6.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M24 33a8.6 8.6 0 0 0 5.96-2.18l-2.91-2.26a5.4 5.4 0 0 1-8.09-2.85h-3v2.33A9 9 0 0 0 24 33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M18.96 25.71a5.41 5.41 0 0 1 0-3.42v-2.33h-3a9 9 0 0 0 0 8.08l3-2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M24 18.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59a9 9 0 0 0-14.06 2.61l3 2.34A5.36 5.36 0 0 1 24 18.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15h18v18H15z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnActive);
export default __webpack_public_path__ + "static/media/btn--active.16f221734743ca6c5a55cce6be2931f8.svg";
export { ForwardRef as ReactComponent };